import partition from 'lodash.partition';
import { isMobileResolution, sortObjectByProperty } from '@philips-internal/oswald-ui-utils';
import { FILTER_ACTION_ID } from '../../../filter/filter-constants.js';
function getActions(actions, inlineLimit, showCollapseButton) {
    const enabledActions = getEnabledActions(actions);
    sortObjectByProperty(enabledActions, 'tabIndex');
    if (isMobileResolution()) {
        const [inline, excess] = partition(enabledActions, (action) => {
            return showCollapseButton
                ? action.inlineOnMobile && enabledActions.length === 1
                : action.inlineOnMobile;
        });
        return {
            excess,
            inline,
        };
    }
    const excess = enabledActions.slice(inlineLimit, enabledActions.length);
    const inline = enabledActions.slice(0, inlineLimit);
    return {
        excess,
        inline,
    };
}
function getEnabledActions(actions) {
    return actions.filter((action) => action.enabled && action.id !== FILTER_ACTION_ID);
}
function getEnabledOptions(options) {
    if (!options) {
        return [];
    }
    return options.filter(option => option.enabled);
}
function getFilterAction(actions) {
    return actions.find((action) => action.id === FILTER_ACTION_ID) ?? null;
}
export { getActions, getEnabledActions, getEnabledOptions, getFilterAction, };
//# sourceMappingURL=heading-context-utils.js.map